(() => {
  const initialize = () => {
    if (!document.querySelector('[data-mh-hero]')) return;
    const host = document.querySelector('#header-component .mayhem-header-utility__inner');
    if (!host || host.querySelector('[data-mayhem-home-vehicle-control]')) return;
    let labels;
    try { labels = JSON.parse(document.getElementById('mayhem-home-vehicle-labels').textContent); } catch { return; }
    const button = document.createElement('button');
    button.type = 'button';
    button.hidden = true;
    button.className = 'mayhem-home-vehicle-control';
    button.setAttribute('data-mayhem-home-vehicle-control', '');
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    const text = document.createElement('span');
    const chevron = document.createElement('span');
    chevron.textContent = '⌄';
    chevron.setAttribute('aria-hidden', 'true');
    button.append(text, chevron);
    host.prepend(button);
    const sync = () => {
      const selected = window.TWGFitmentPreview?.selectedVehicle();
      text.textContent = selected ? labels.change : labels.select;
      button.title = selected?.label || labels.select;
    };
    button.addEventListener('click', () => window.mayhemOpenVehiclePicker?.(button));
    ['twg:vehicle-changed','twg:vehicle-restore','mayhem:vehicle-changed','pageshow'].forEach(name => window.addEventListener(name, sync));
    const syncScroll = () => {
      const root = matchMedia('(min-width:990px)').matches
        ? document.querySelector('.page-wrapper') || document.scrollingElement
        : document.scrollingElement;
      const visible = (root?.scrollTop || 0) > 2;
      if (!visible && button.getAttribute('aria-expanded') === 'true') {
        window.mayhemOpenVehiclePicker?.(button);
      }
      button.hidden = !visible;
      document.getElementById('header-component')?.toggleAttribute('data-mayhem-home-scrolled', visible);
    };
    let frame = 0;
    const queueScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; syncScroll(); });
    };
    document.addEventListener('scroll', queueScroll, {passive:true,capture:true});
    window.addEventListener('resize', queueScroll);
    window.addEventListener('pageshow', queueScroll);
    sync();
    syncScroll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
